import SalesChallengeRegister from './SalesChallengeRegister';
export default SalesChallengeRegister;
